<template>
  <div class="content">
    <v-card>
      <v-card-title>
        <TitleWithButton
          title="Agendamento de Desconto"
          buttonText="novo agendamento"
          :buttonFunction="() => (this.scheduleModal = true)"
        />
      </v-card-title>

      <v-card-text>
        <v-tabs v-model="currentTab">
          <v-tab>Ativos</v-tab>
          <v-tab>Inativos</v-tab>

          <v-tab-item v-model="currentTab">
            <v-data-table
              :headers="headers"
              :items="currentTab == 0 ? activePromotions : inactivePromotions"
              hide-default-footer
              class="elevation-1 mt-2"
              no-data-text="nenhum agendamento registrado"
            >
              <template v-slot:item="{ item }">
                <tr>
                  <td>{{ item.begin_date | formatDate }}</td>
                  <td>{{ item.end_date | formatDate }}</td>
                  <td>{{ item.promotion_value | formatValue }}</td>
                  <td>{{ item.basic_value | formatValue }}</td>
                  <td>{{ item.km_promotion_value | formatValue }}</td>
                  <td>{{ item.km_basic_value | formatValue }}</td>
                  <td>
                    {{ formatVehicleCategoryName(item.vehicle_category_id) }}
                  </td>
                  <td class="text-xs-right">
                    <ActionButton
                      message="Excluir agendamento"
                      icon="delete"
                      color="error"
                      @onclick="cancelSchedule(item.id)"
                    />
                  </td>
                </tr>
              </template>
            </v-data-table>

            <div class="text-xs-center pt-2">
              <v-pagination
                v-model="page"
                :length="currentTab == 0 ? pagesActive : pagesInactive"
                total-visible="10"
                @input="nextPage"
              >
              </v-pagination>
            </div>
          </v-tab-item>
        </v-tabs>
      </v-card-text>
    </v-card>

    <!-- Modal de cadastro -->
    <v-dialog v-model="scheduleModal" persistent max-width="600">
      <v-card>
        <v-card-title>Agendamento de desconto</v-card-title>

        <v-card-text>
          <v-flex class="my-2">
            <v-row justify="start">
              <v-flex xs12 md4>
                <v-col>
                  <v-select
                    v-model="schedulePromotion.vehicle_category_id"
                    :items="vehicleCategories"
                    item-text="name"
                    item-value="id"
                    label="Categoria de veículo"
                    @change="getClients()"
                    required
                  />
                </v-col>
              </v-flex>

              <v-flex xs12 md8>
                <v-col>
                  <v-select
                    v-model="schedulePromotion.clients"
                    :disabled="clients.length > 0 ? false : true"
                    :items="clients"
                    label="Clientes"
                    item-text="name"
                    item-value="id"
                    multiple
                    required
                    placeholder="Selecione os clientes"
                  >
                    <template v-slot:selection="{ item, index }">
                      <span v-if="index === 0">{{ item.name }} </span>

                      <span v-if="index === 1" class="grey--text">
                        (+{{ schedulePromotion.clients.length - 1 }} outros)
                      </span>
                    </template>

                    <template v-slot:prepend-item>
                      <v-list-item
                        ripple
                        @mousedown.prevent
                        @click="selectClient"
                      >
                        <v-list-item-action>
                          <v-icon
                            :color="
                              schedulePromotion.clients.length > 0
                                ? 'indigo darken-4'
                                : ''
                            "
                          >
                            {{ iconInSelect }}
                          </v-icon>
                        </v-list-item-action>

                        <v-list-item-content>
                          Selecionar todos
                        </v-list-item-content>
                      </v-list-item>

                      <v-divider class="mt-2"></v-divider>
                    </template>
                  </v-select>
                </v-col>
              </v-flex>
            </v-row>
          </v-flex>

          <v-flex class="my-1">
            <v-row justify="start">
              <v-flex xs12 md6>
                <v-col>
                  <label for="model">Preço promocional (Hora Avulsa):</label>
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span
                        class="input-group-text font-weight-medium"
                        id="basic-addon1"
                        >R$</span
                      >
                    </div>
                    <money
                      v-model="schedulePromotion.promotion_value"
                      v-bind="money"
                      class="form-control"
                    ></money>
                  </div>
                </v-col>
              </v-flex>

              <v-flex xs12 md6>
                <v-col>
                  <label for="model">Preço normal (Hora Avulsa):</label>
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span
                        class="input-group-text font-weight-medium"
                        id="basic-addon1"
                        >R$</span
                      >
                    </div>
                    <money
                      v-model="schedulePromotion.basic_value"
                      v-bind="money"
                      class="form-control"
                    ></money>
                  </div>
                </v-col>
              </v-flex>
            </v-row>
          </v-flex>

          <v-flex class="my-1">
            <v-row justify="start">
              <v-flex xs12 md6>
                <v-col>
                  <label for="model">Preço promocional (KM):</label>
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span
                        class="input-group-text font-weight-medium"
                        id="basic-addon1"
                        >R$</span
                      >
                    </div>
                    <money
                      v-model="schedulePromotion.km_promotion_value"
                      v-bind="money"
                      class="form-control"
                    ></money>
                  </div>
                </v-col>
              </v-flex>

              <v-flex xs12 md6>
                <v-col>
                  <label for="model">Preço normal (KM):</label>
                  <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span
                        class="input-group-text font-weight-medium"
                        id="basic-addon1"
                        >R$</span
                      >
                    </div>
                    <money
                      v-model="schedulePromotion.km_basic_value"
                      v-bind="money"
                      class="form-control"
                    ></money>
                  </div>
                </v-col>
              </v-flex>
            </v-row>
          </v-flex>

          <v-flex class="my-1">
            <v-row justify="start">
              <v-flex xs12 md6>
                <v-col>
                  <v-menu
                    v-model="menuInicio"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="schedulePromotion.begin_date"
                        label="Início da promoção"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="schedulePromotion.begin_date"
                      @input="menuInicio = false"
                      locale="pt-br"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-flex>

              <v-flex xs12 md6>
                <v-col>
                  <v-menu
                    v-model="menuFim"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="schedulePromotion.end_date"
                        label="Fim da promoção"
                        readonly
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="schedulePromotion.end_date"
                      @input="menuFim = false"
                      locale="pt-br"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-flex>
            </v-row>
          </v-flex>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="
              scheduleModal = false;
              cleanForm();
            "
          >
            Cancelar
          </v-btn>
          <v-btn color="blue darken-1" @click="createSchedule()">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from 'moment';
import ActionButton from '../shared/ActionButtonsTemplate';

import ClientController from '../../controllers/ClientController';
import VehicleCategoryController from '../../controllers/VehicleCategoryController.js';
import SchedulePromotionVehicleCategory from '../../controllers/SchedulePromotionVehicleCategory?v=1';
import TitleWithButton from '../../UIComponents/titleWithButton.vue';

export default {
  components: { ActionButton, TitleWithButton },

  data() {
    return {
      schedulePromotionController: new SchedulePromotionVehicleCategory(
        this.$resource
      ),
      vehicleCategoryController: new VehicleCategoryController(this.$resource),
      clientController: new ClientController(this.$resource),

      currentTab: null,

      menuInicio: false,
      menuFim: false,

      clients: [],
      vehicleCategories: [],
      scheduleModal: false,

      pagesActive: 1,
      paginationActivePage: 1,
      pagesInactive: 1,
      paginationInactivePage: 1,

      activePromotions: [],
      inactivePromotions: [],

      schedulePromotion: {
        begin_date: null,
        end_date: null,
        promotion_value: 0,
        basic_value: 0,
        km_promotion_value: 0.0,
        km_basic_value: 0.0,
        vehicle_category_id: null,
        clients: [],
      },

      money: {
        decimal: ',',
        thousands: '.',
        precision: 2,
        masked: true,
      },

      headers: [
        { text: 'Data inicial', value: 'begin_date' },
        { text: 'Data final', value: 'end_date' },
        { text: 'Preço promocional (Hora Avulsa)', value: 'promotion_value' },
        { text: 'Preço básico (Hora Avulsa)', value: 'basic_value' },
        { text: 'Preço promocional (KM)', value: 'km_promotion_value' },
        { text: 'Preço básico (KM)', value: 'km_basic_value' },
        { text: 'Categoria', value: 'vehicle_category_id' },
        { text: 'Ações', value: 'action', sortable: false },
      ],
    };
  },

  computed: {
    page: {
      // getter
      get: function() {
        return this.currentTab == 0
          ? this.paginationActivePage
          : this.paginationInactivePage;
      },
      // setter
      set: function(newValue) {
        if (this.currentTab == 0) {
          this.paginationActivePage = newValue;
        } else {
          this.paginationInactivePage = newValue;
        }
      },
    },

    selectAllClients() {
      return this.schedulePromotion.clients.length === this.clients.length;
    },

    selectAnClient() {
      return (
        this.schedulePromotion.clients.length > 0 && !this.selectAllClients
      );
    },

    iconInSelect() {
      if (this.selectAllClients) return 'mdi-close-box';
      if (this.selectAnClient) return 'mdi-minus-box';
      return 'mdi-checkbox-blank-outline';
    },
  },

  created() {
    this.getVehicleCategories();
    this.getAllSchedulePromotion();
  },

  methods: {
    selectClient() {
      this.$nextTick(() => {
        if (this.selectAllClients) {
          this.schedulePromotion.clients = [];
        } else {
          this.schedulePromotion.clients = this.clients.slice();
        }
      });
    },

    async getVehicleCategories() {
      try {
        this.vehicleCategories = await this.vehicleCategoryController.getAll();
      } catch (error) {
        this.$awn.alert('Falha ao recuperar categorias de veículos');
      }
    },

    // Melhora a legibilidade do valor da categoria na tabela
    formatVehicleCategoryName(categoryId) {
      return this.vehicleCategories.find(cat => cat.id == categoryId).name;
    },

    getClients() {
      if (Boolean(this.schedulePromotion.vehicle_category_id)) {
        let vehicleCategoryId = this.schedulePromotion.vehicle_category_id;
        return this.getClientsByVehicleCategory(vehicleCategoryId);
      }
      return [];
    },

    async getClientsByVehicleCategory(vehicleCategoryId) {
      try {
        this.clients = await this.clientController.getClientsByVehicleCategory(
          vehicleCategoryId
        );
      } catch (error) {
        this.$awn.alert('Falha ao recuperar clientes');
      }
    },

    async getActiveSchedulePromotion() {
      try {
        this.blockScreen = true;
        let response = await this.schedulePromotionController.getOnlyActive(
          this.paginationActivePage
        );

        this.activePromotions = response.data;
        this.pagesActive = Math.ceil(response.count / 10);
      } catch (error) {
        this.$awn.alert('Falha ao recuperar agendamentos ativos');
      } finally {
        this.blockScreen = false;
      }
    },

    async getInactiveSchedulePromotion() {
      try {
        this.blockScreen = true;
        let response = await this.schedulePromotionController.getOnlyInactive(
          this.paginationInactivePage
        );

        this.inactivePromotions = response.data;
        this.pagesInactive = Math.ceil(response.count / 10);
      } catch (error) {
        this.$awn.alert('Falha ao recuperar agendamentos desativados');
      } finally {
        this.blockScreen = false;
      }
    },

    async getAllSchedulePromotion() {
      this.getActiveSchedulePromotion();
      this.getInactiveSchedulePromotion();
    },

    async nextPage() {
      if (this.currentTab == 0) {
        return this.getActiveSchedulePromotion();
      }
      return this.getInactiveSchedulePromotion();
    },

    cancelSchedule(schedulePromotionId) {
      this.schedulePromotionController
        .delete(schedulePromotionId)
        .then(res => {
          this.$awn.success(res.message);
          this.getAllSchedulePromotion();
        })
        .catch(err => this.$awn.alert(err.message));
    },

    createSchedule() {
      if (
        !Boolean(this.schedulePromotion.begin_date) ||
        !Boolean(this.schedulePromotion.end_date)
      ) {
        this.$awn.alert(
          'Você precisa selecionar as datas de início e término da promoção'
        );
        return;
      }

      if (this.schedulePromotion.begin_date > this.schedulePromotion.end_date) {
        this.$awn.alert('A data inicial deve ser menor que a data final');
        return;
      }

      if (this.schedulePromotion.begin_date < moment().format('yyyy-MM-DD')) {
        this.$awn.alert('A data inicial deve ser maior que a data atual');
        return;
      }

      if (
        this.schedulePromotion.clients == null ||
        this.schedulePromotion.clients.length == 0
      ) {
        this.$awn.alert('Selecione os clientes');
        return;
      }

      if (
        this.moneyStringToNumber(this.schedulePromotion.promotion_value) <= 0 ||
        this.moneyStringToNumber(this.schedulePromotion.basic_value) <= 0 ||
        this.moneyStringToNumber(this.schedulePromotion.km_promotion_value) <=
          0 ||
        this.moneyStringToNumber(this.schedulePromotion.km_basic_value) <= 0
      ) {
        this.$awn.alert('Todos os valores devem ser maior do que R$ 0,00');
        return;
      }

      this.schedulePromotionController
        .create(this.schedulePromotion)
        .then(res => {
          this.$awn.success(res.message);
          this.getAllSchedulePromotion();
        })
        .catch(err => this.$awn.alert(err.message));

      this.scheduleModal = false;
      this.cleanForm();
    },

    cleanForm() {
      this.schedulePromotion = {
        begin_date: null,
        end_date: null,
        promotion_value: 0,
        basic_value: 0,
        km_promotion_value: 0.0,
        km_basic_value: 0.0,
        vehicle_category_id: null,
        clients: [],
      };

      this.clients = [];
    },

    moneyStringToNumber(string) {
      string = string.replace(',', '');
      string = string.replaceAll('.', '');
      return string;
    },
  },

  filters: {
    formatDate(dateString) {
      if (dateString) {
        return moment(dateString).format('DD[/]MM[/]YYYY');
      }
    },

    formatValue(value) {
      let valorFloat = parseFloat(value / 100);
      return 'R$ ' + valorFloat.toFixed(2).replace('.', ',');
    },
  },
};
</script>
